import { connect } from "react-redux";

import Crossword from "./Crossword";
import { getShowPrizes } from "../../reducers/ui/selectors";

const mapStateToProps = state => ({
  prizesShowing: getShowPrizes(state)
});

export default connect(mapStateToProps)(Crossword);



// WEBPACK FOOTER //
// ./src/components/Crossword/CrosswordContainer.js